// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__dJBBr","label":"LabeledBox_label__6lxHE"};